{
  "name": "typegpu",
  "private": true,
  "version": "0.5.9",
  "description": "A thin layer between JS and WebGPU/WGSL that improves development experience and allows for faster iteration.",
  "license": "MIT",
  "type": "module",
  "exports": {
    "./package.json": "./package.json",
    ".": "./src/index.ts",
    "./data": "./src/data/index.ts",
    "./std": "./src/std/index.ts"
  },
  "publishConfig": {
    "directory": "dist",
    "linkDirectory": false,
    "main": "./dist/index.js",
    "types": "./dist/index.d.ts",
    "exports": {
      "./package.json": "./dist/package.json",
      ".": {
        "types": "./dist/index.d.ts",
        "module": "./dist/index.js",
        "import": "./dist/index.js",
        "default": "./dist/index.cjs"
      },
      "./data": {
        "types": "./dist/data/index.d.ts",
        "module": "./dist/data/index.js",
        "import": "./dist/data/index.js",
        "default": "./dist/data/index.cjs"
      },
      "./std": {
        "types": "./dist/std/index.d.ts",
        "module": "./dist/std/index.js",
        "import": "./dist/std/index.js",
        "default": "./dist/std/index.cjs"
      }
    }
  },
  "sideEffects": false,
  "scripts": {
    "build": "tsup",
    "test:types": "pnpm tsc --p ./tsconfig.test.json --noEmit",
    "prepublishOnly": "tgpu-dev-cli prepack"
  },
  "engines": {
    "node": ">=12.20.0"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/software-mansion/TypeGPU.git"
  },
  "keywords": [
    "webgpu",
    "wgpu",
    "wgsl",
    "typescript",
    "compute",
    "shader",
    "shaders",
    "gpgpu"
  ],
  "bugs": {
    "url": "https://github.com/software-mansion/TypeGPU/issues"
  },
  "homepage": "https://typegpu.com",
  "devDependencies": {
    "@ark/attest": "^0.46.0",
    "@typegpu/tgpu-dev-cli": "workspace:*",
    "@types/node": "^22.13.14",
    "@webgpu/types": "catalog:",
    "arktype": "catalog:",
    "jiti": "^2.4.2",
    "tgpu-jit": "workspace:*",
    "tsup": "catalog:",
    "typescript": "catalog:",
    "unplugin-typegpu": "workspace:*",
    "wesl": "0.6.7",
    "wgpu-matrix": "^3.4.0"
  },
  "packageManager": "pnpm@10.4.1+sha512.c753b6c3ad7afa13af388fa6d808035a008e30ea9993f58c6663e2bc5ff21679aa834db094987129aa4d488b86df57f7b634981b2f827cdcacc698cc0cfb88af",
  "dependencies": {
    "tinyest": "workspace:~0.1.1",
    "typed-binary": "^4.3.1"
  }
}
